var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDuplicate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12.142 12.142"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Duplicate",
  transform: "translate(-737 -91)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3916",
  "data-name": "Group 3916",
  transform: "translate(737 94.373)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4854",
  "data-name": "Path 4854",
  d: "M743.745,104.769h-4.722A2.026,2.026,0,0,1,737,102.745V98.024A2.026,2.026,0,0,1,739.024,96h4.722a2.026,2.026,0,0,1,2.024,2.024v4.722A2.026,2.026,0,0,1,743.745,104.769Zm-4.722-7.42a.676.676,0,0,0-.674.675v4.722a.676.676,0,0,0,.674.675h4.722a.676.676,0,0,0,.675-.675V98.024a.676.676,0,0,0-.675-.675Z",
  transform: "translate(-737 -96)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3917",
  "data-name": "Group 3917",
  transform: "translate(740.373 91)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4855",
  "data-name": "Path 4855",
  d: "M748.745,99.769h-2.024a.675.675,0,1,1,0-1.349h2.024a.676.676,0,0,0,.674-.675V93.024a.676.676,0,0,0-.674-.675h-4.722a.676.676,0,0,0-.675.675v2.024a.675.675,0,1,1-1.349,0V93.024A2.026,2.026,0,0,1,744.024,91h4.722a2.026,2.026,0,0,1,2.024,2.024v4.722A2.026,2.026,0,0,1,748.745,99.769Z",
  transform: "translate(-742 -91)"
})))));
export default SvgIconDuplicate;